/** Picks v2 or v1 of the Search configuration page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../utils/redesignFlag';
import SearchPage   from './SearchPage';
import SearchPageV2 from './v2/SearchPageV2';

export default function SearchPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SearchPageV2 : SearchPage;
  return <Component {...props} />;
}
